export default __webpack_public_path__ + "static/sms-9f207903b239fa163eb054a2f851944d.jpg";